import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ApsListPage } from "../../pages/aps-list";
import { HomePage } from "../../pages/home";
import { NotFoundPage } from "../../pages/notfound";
import PAGE from "./page";

export default function Router() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Switch>
        <Route exact path={`${PAGE.APS_LIST}`} component={ApsListPage} />
        <Route exact path={`${PAGE.APS_HOME}`} component={HomePage} />

        <Route exact path="*" component={NotFoundPage} />
      </Switch>
    </BrowserRouter>
  )
}
